import {
  Box,
  Tabs,
  Tab,
  CardMedia,
  Chip,
  Avatar,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

type DayOfWeek =
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday"
  | "Sunday";

interface Availability {
  enabled: boolean;
  start: string;
  end: string;
}

const ProductDetail = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [availability] = useState<Record<DayOfWeek, Availability>>({
    Monday: { enabled: true, start: "09:00", end: "18:00" },
    Tuesday: { enabled: true, start: "10:00", end: "17:00" },
    Wednesday: { enabled: false, start: "09:00", end: "18:00" },
    Thursday: { enabled: true, start: "09:00", end: "18:00" },
    Friday: { enabled: true, start: "09:00", end: "20:00" },
    Saturday: { enabled: false, start: "09:00", end: "18:00" },
    Sunday: { enabled: false, start: "09:00", end: "18:00" },
  });

  const product = {
    images: ["/static/images/placeholder.png"],
    title: "Sample Product Title",
    price: 120.0,
    category: "Books",
    subcategory: "Commp.",
    address: "123 Main Street, New York, NY",
    description: "This is a sample product description.",
    features: [
      {
        title: "Verified",
        logo: "/static/images/tick_icon.svg",
        description: "Yes",
      },
      { title: "Warranty", logo: "", description: "1 Year" },
    ],
    analytics: {
      viewsToday: 124,
      views7d: 1023,
      totalViews: 15024,
      reports: [
        {
          id: 1,
          title: "Wrong product received",
          when: "2025-10-01",
          type: "complaint",
          reporter: "john.doe",
        },
        {
          id: 2,
          title: "Inaccurate description on page",
          when: "2025-09-28",
          type: "report",
          reporter: "jane.smith",
        },
        {
          id: 3,
          title: "Packaging damaged",
          when: "2025-09-26",
          type: "complaint",
          reporter: "alex.k",
        },
      ],
    },
    activity: [
      {
        id: 1,
        user: "admin",
        action: "Edited product details",
        when: "2025-10-01 10:22",
      },
      {
        id: 2,
        user: "qa_user",
        action: "Uploaded new images",
        when: "2025-09-30 16:05",
      },
      {
        id: 3,
        user: "admin",
        action: "Updated pricing",
        when: "2025-09-29 09:47",
      },
    ],
  };

  const viewsData = [
    { name: "Mon", views: 120 },
    { name: "Tue", views: 210 },
    { name: "Wed", views: 180 },
    { name: "Thu", views: 300 },
    { name: "Fri", views: 260 },
    { name: "Sat", views: 140 },
    { name: "Sun", views: 170 },
  ];

  const reportsData = [
    { name: "Mon", reports: 2, complaints: 1 },
    { name: "Tue", reports: 1, complaints: 0 },
    { name: "Wed", reports: 3, complaints: 2 },
    { name: "Thu", reports: 2, complaints: 1 },
    { name: "Fri", reports: 4, complaints: 3 },
    { name: "Sat", reports: 1, complaints: 1 },
    { name: "Sun", reports: 2, complaints: 1 },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Product Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-products")}>
            Manage Product Listing
          </button>{" "}
          - Product Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Product Info" {...a11yProps(0)} />
              <Tab label="Monitor Analytics" {...a11yProps(1)} />
              <Tab label="User Activity" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards view_page">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="gap_p">
            <div className="vew_img v2 no_radius w_100">
              <h6>Product Images/Videos</h6>
              <figure>
                {product.images[0] ? (
                  <CardMedia
                    component="img"
                    image={product.images[0]}
                    alt="Product"
                  />
                ) : (
                  <img alt="placeholder" src="/static/images/placeholder.png" />
                )}
              </figure>
            </div>
            <div className="w_33">
              <h6>Product Title</h6>
              <p>{product.title}</p>
            </div>
            <div className="w_33">
              <h6>Price</h6>
              <p>${product.price.toFixed(2)}</p>
            </div>
            <div className="w_33">
              <h6>Category</h6>
              <p>{product.category}</p>
            </div>
            <div className="w_33">
              <h6>Sub Category</h6>
              <p>{product.subcategory}</p>
            </div>
            <div className="w_66">
              <h6>Address</h6>
              <p>{product.address}</p>
            </div>
            <div className="w_66">
              <h6>Booster Plan</h6>
              <p>{"For 30 days GH£ 500"}</p>
            </div>
            <div className="w_100">
              <h6>Description</h6>
              <p>{product.description}</p>
            </div>
            {/* <div className="w_100">
              <h6>Features</h6>
              <div className="gap_p">
                {product.features.map((f, i) => (
                  <div key={i}>
                    <Chip
                      key={f.title}
                      avatar={
                        f.logo ? (
                          <Avatar src={f.logo} />
                        ) : (
                          <Avatar>{f.title.charAt(0).toUpperCase()}</Avatar>
                        )
                      }
                      label={`${f.title}${
                        f.description ? `: ${f.description}` : ""
                      }`}
                    />
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="grid_sc gap_m">
            <div className="cards table_card">
              <div className="cards_header">
                <div className="left_s">
                  <h2>Views</h2>
                </div>
                <div className="right_s">
                  <p>
                    <span>A day</span>
                    <span>A week</span>
                    <span>A month</span>
                    <span>A year</span>
                  </p>
                  <Button className="btn btn_black icon_btn">
                    <FileDownloadIcon />
                  </Button>
                </div>
              </div>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={viewsData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="views" fill="#38B6FF" />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="cards table_card">
              <div className="cards_header">
                <div className="left_s">
                  <h2>Reports & Complaints</h2>
                </div>
                <div className="right_s">
                  <p>
                    <span>A day</span>
                    <span>A week</span>
                    <span>A month</span>
                    <span>A year</span>
                  </p>
                  <Button className="btn btn_black icon_btn">
                    <FileDownloadIcon />
                  </Button>
                </div>
              </div>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={reportsData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="reports" fill="#38B6FF" />
                  {/* <Bar dataKey="complaints" fill="#d32f2f" /> */}
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="gap_p">
            <div className="w_100">
              <h6>User Activity</h6>
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow hover>
                      <TableCell>Id</TableCell>
                      <TableCell>User</TableCell>
                      <TableCell>Action</TableCell>
                      <TableCell>Date</TableCell>
                      {/* <TableCell>Action</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {product.activity.map((row) => (
                      <TableRow hover key={row.id}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>
                          <Box className="user_block">
                            <p>
                              <b>{row.user}</b>
                            </p>
                          </Box>
                        </TableCell>
                        <TableCell>{row.action}</TableCell>
                        <TableCell>{row.when}</TableCell>
                        {/* <TableCell>
                          <div className="table_actions v2">
                            <IconButton onClick={() => navigate("/manage-products/detail") }>
                              <img src="/static/images/eye_icon.svg" alt="" />
                            </IconButton>
                            <IconButton>
                              <img src="/static/images/trash2_icon.svg" alt="" />
                            </IconButton>
                          </div>
                        </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ProductDetail;
